module.exports = __webpack_public_path__ + "img/dmpLogo.646f1c57.png";